<template>
  <div>
    <v-container grid-list-xl style="padding: 5px; margin-top: 0px;">
          <v-layout fluid row wrap>
            <v-flex sm12 xs12 md12 lg12>
              <!-- <DetectiveLoading /> -->
              
    <form id="search-form" dark @submit.prevent="submitQuery">
      <div>
        <textarea
          autocomplete="on"
          autocorrect="on"
          autocapitalize="on"
          spellcheck="true"
          onload="this.focus()"
          type="text"
          name="q"
          placeholder="Describe your case objectives here:"
          v-model="queryPrompt"
          rows="4"
          cols="500"
          class="form-control-6 input is-success inputarea card-animate-2"
          @keyup.enter="submitQuery"
        ></textarea>
      </div>
      <div>
        <div elevation="3" class="chart-content-5" style="padding-block: 20px;">
          <v-container grid-list-xl style="padding: 10px; top:20px">
            <v-row>
              <v-col cols="12">
                <h3>Abductee</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="2">
                <div v-if="abducteeImage" class="abductee-image-container">
                  <img :src="abducteeImage" alt="Abductee" />
                </div>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field class="inputarea2 card-animate-2" v-model="abductee" label="Abductee"></v-text-field>
                <v-switch
                  v-model="abductee"
                  color="success"
                  value=""
                  hide-details
                  @change="playSound(submitAudio)"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field class="inputarea2 card-animate-2" v-model="abducteedob" label="D.O.B."></v-text-field>
                <v-switch
                  v-model="abducteedob"
                  color="success"
                  value=""
                  hide-details
                  @change="playSound(submitAudio)"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field class="inputarea2 card-animate-2" v-model="missingSince" label="Missing Since"></v-text-field>
                <v-switch
                  v-model="missingSince"
                  color="success"
                  value=""
                  hide-details
                  @change="playSound(submitAudio)"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field class="inputarea2 card-animate-2" v-model="abducteeSocialMedia" label="Abductee Social Media Profiles"></v-text-field>
                <v-switch
                  v-model="abducteeSocialMedia"
                  color="success"
                  value=""
                  hide-details
                  @change="playSound(submitAudio)"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="2">
                <input type="file" @change="uploadImage($event, 'abducteeImage')" accept="image/*">
              </v-col>
            </v-row>
          </v-container>
        </div>
        <div elevation="3" class="chart-content-5" style="padding-block: 20px;">
          <v-container grid-list-xl style="padding: 10px; top:20px">
            <v-row>
              <v-col cols="12">
                <h3>Abductee</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="2">
                <div v-if="abducteeImageNew" class="abductee-image-container">
                  <img :src="abducteeImageNew" alt="AbducteeNew" />
                </div>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field class="inputarea2 card-animate-2" v-model="abducteeNew" label="Abductee New"></v-text-field>
                <v-switch
                  v-model="abducteeNew"
                  color="success"
                  value=""
                  hide-details
                  @change="playSound(submitAudio)"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field class="inputarea2 card-animate-2" v-model="abducteedobNew" label="D.O.B. New"></v-text-field>
                <v-switch
                  v-model="abducteedobNew"
                  color="success"
                  value=""
                  hide-details
                  @change="playSound(submitAudio)"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field class="inputarea2 card-animate-2" v-model="missingSinceNew" label="Missing Since New"></v-text-field>
                <v-switch
                  v-model="missingSinceNew"
                  color="success"
                  value=""
                  hide-details
                  @change="playSound(submitAudio)"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="2">
                <v-text-field class="inputarea2 card-animate-2" v-model="abducteeSocialMediaNew" label="Abductee Social Media Profiles New"></v-text-field>
                <v-switch
                  v-model="abducteeSocialMediaNew"
                  color="success"
                  value=""
                  hide-details
                  @change="playSound(submitAudio)"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="2">
                <input type="file" @change="uploadImage($event, 'abducteeImageNew')" accept="image/*">
              </v-col>
            </v-row>
          </v-container>
        </div>
        <div elevation="3" class="chart-content-5" style="padding-block: 20px;">
          <v-container grid-list-xl style="padding: 10px; top:20px">
            <v-row>
              <v-col cols="12">
                <h3>Abductor</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3">
                <div v-if="abductorImage" class="abductee-image-container">
                  <img :src="abductorImage" alt="Abductor" />
                </div>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field class="inputarea2 card-animate-2" v-model="abductor" label="Abductor"></v-text-field>
                <v-switch
                  v-model="abductor"
                  color="success"
                  value=""
                  hide-details
                  @change="playSound(submitAudio)"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field class="inputarea2 card-animate-2" v-model="abductordob" label="Abductor D.O.B."></v-text-field>
                <v-switch
                  v-model="abductordob"
                  color="success"
                  value=""
                  hide-details
                  @change="playSound(submitAudio)"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field class="inputarea2 card-animate-2" v-model="abductorSocialMedia" label="Abductor Social Media Profiles"></v-text-field>
                <v-switch
                  v-model="abductorSocialMedia"
                  color="success"
                  value=""
                  hide-details
                  @change="playSound(submitAudio)"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field class="inputarea2 card-animate-2" v-model="lastKnownAddress" label="Last Known Address"></v-text-field>
                <v-switch
                  v-model="lastKnownAddress"
                  color="success"
                  value=""
                  hide-details
                  @change="playSound(submitAudio)"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field class="inputarea2 card-animate-2" v-model="motive" label="Motive"></v-text-field>
                <v-switch
                  v-model="motive"
                  color="success"
                  value=""
                  hide-details
                  @change="playSound(submitAudio)"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field class="inputarea2 card-animate-2" v-model="abducteeRecoveryRescue" label="Abductee Recovery/Rescue"></v-text-field>
                <v-switch
                  v-model="abducteeRecoveryRescue"
                  color="success"
                  value=""
                  hide-details
                  @change="playSound(submitAudio)"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="2">
                <input type="file" @change="uploadImage($event, 'abductorImage')" accept="image/*">
              </v-col>
            </v-row>
          </v-container>
        </div>
        <div elevation="3" class="chart-content-5" style="padding-block: 20px;">
          <v-container grid-list-xl style="padding: 10px; top:20px">
            <v-row>
              <v-col cols="12">
                <h3>Abduction</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3">
                <v-text-field class="inputarea2 card-animate-2" v-model="familyCountry" label="Family Country"></v-text-field>
                <v-switch
                  v-model="familyCountry"
                  color="success"
                  value=""
                  hide-details
                  @change="playSound(submitAudio)"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field class="inputarea2 card-animate-2" v-model="abductorSocialMedia" label="Abductor Social Media Profiles"></v-text-field>
                <v-switch
                  v-model="abductorSocialMedia"
                  color="success"
                  value=""
                  hide-details
                  @change="playSound(submitAudio)"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field class="inputarea2 card-animate-2" v-model="lastKnownAddress" label="Last Known Address"></v-text-field>
                <v-switch
                  v-model="lastKnownAddress"
                  color="success"
                  value=""
                  hide-details
                  @change="playSound(submitAudio)"
                ></v-switch>
              </v-col>
              <v-col cols="12" md="3">
                <div class="inputarea2 card-animate-2">
                  <label>
                    <input type="radio" v-model="caseType" value="International" />
                    International
                  </label>
                  <label>
                    <input type="radio" v-model="caseType" value="Domestic" />
                    Domestic
                  </label>
                  <v-switch
                    v-model="caseType"
                    color="success"
                    value=""
                    hide-details
                    @change="playSound(submitAudio)"
                  ></v-switch>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
        <div elevation="3" class="chart-content-5" style="padding-block: 20px;">
          <v-container grid-list-xl style="padding: 10px; top:20px">
            <v-row>
              <v-col cols="12">
                <h3>Family Tree</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-form>
                  <v-select
                    v-model="familyRelation"
                    :items="['Son', 'Daughter', 'Mom', 'Dad', 'Grandma', 'Grandpa', 'Aunt', 'Uncle', 'Cousin', 'Other']"
                    label="Select Relationship"
                  ></v-select>
                  <v-text-field v-model="familyMemberName" label="Name"></v-text-field>
                  <v-btn @click="addFamilyMember">Add Family Member</v-btn>
                </v-form>
                <div id="familyTree">
                  <div class="generation" id="grandParents">
                    <div class="pair" v-for="pair in familyTree.grandParents" :key="pair.id">
                      <div class="card-m">{{ pair.grandpa }}</div>
                      <div class="card-f">{{ pair.grandma }}</div>
                    </div>
                  </div>
                  <div class="generation" id="parents">
                    <div class="pair">
                      <div class="card-m">{{ familyTree.parents.dad }}</div>
                      <div class="card-f">{{ familyTree.parents.mom }}</div>
                    </div>
                  </div>
                  <div class="generation" id="children">
                    <div class="card-m" v-for="child in familyTree.children" :key="child.id">{{ child.name }}</div>
                  </div>
                  <div class="generation" id="extendedFamily">
                    <div v-for="member in familyTree.extendedFamily" :key="member.id">
                      <div>{{ member.relation }}: {{ member.name }}</div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
      <br />
      <br />
      <div>
        <v-btn class="mx-2" type="submit" value="Submit">Submit</v-btn>
        <v-btn class="mx-2" type="submit" value="Reset" @click="resetDialogue">Reset</v-btn>
        <v-btn v-if="editingQueryIndex !== -1" class="mx-2" type="submit" value="Update" @click="updateQuery">Update</v-btn>
        <v-btn @click="addNewDataSet" class="mx-2">Add Data</v-btn>
        <v-btn @click="deleteDataSet" class="mx-2">Delete Data</v-btn>
      </div>
    </form>

    <div id="dialogueResults">
      <p v-for="(entry, index) in dialogueHistory" :key="index" v-html="entry" class="text2"></p>
    </div>
    <br />
    <div v-if="loading" class="loading-container">
      <img class="mx-auto d-block" style="height: 15%; width: 15%" src="../assets/images/loading-spinner15.gif" alt="Loading" />
      <br />
      <p>{{ loadingText }}</p>
    </div>
    <div v-if="foundDataMessage" class="found-data-message">{{ foundDataMessage }}</div>
    <div v-if="actionSteps.length">
      <p>Recommended Action Steps:</p>
      <ul>
        <li v-for="(step, index) in actionSteps" :key="index">{{ step }}</li>
      </ul>
    </div>
    <div>
      <v-btn class="mx-2" @click="saveQuery">Save Query</v-btn>
      <v-btn class="mx-2" @click="saveResearch">Save Research</v-btn>
    </div>
    <br />
    <br />
    <v-divider></v-divider>
    <!-- <saved-query-list
      :saved-queries="savedQueries"
      @edit-query="editSavedQuery"
      @delete-query="deleteSavedQuery"
    ></saved-query-list>
    <br /> -->
    <!-- <PersonSearchAI /> -->
    <!-- <PersonDataSearchAI /> -->
    <div elevation="3" class="chart-content-5" style="padding-block: 20px;" id="code4">
    <v-row>
      <v-col cols="12">
        <h3>Online Search</h3>
      </v-col>
    </v-row>
    <v-form ref="searchForm" @submit.prevent="submitSearchNew">
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
            class="inputarea2 card-animate-2"
            v-model="abductor"
            label="Abductor"
            @input="populateForm"
          ></v-text-field>
          <v-switch
            v-model="abductor"
            color="success"
            value=""
            hide-details
            @change="playSound(submitAudio)"
          ></v-switch>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            class="inputarea2 card-animate-2"
            v-model="lastKnownAddress"
            label="Last Known Address"
            @input="populateForm"
          ></v-text-field>
          <v-switch
            v-model="lastKnownAddress"
            color="success"
            value=""
            hide-details
            @change="playSound(submitAudio)"
          ></v-switch>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field v-model="firstName" label="First Name" required></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field v-model="lastName" label="Last Name" required></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field v-model="city" label="City" required></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field v-model="state" label="State" required></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-btn type="submit">Search</v-btn>
        </v-col>
      </v-row>
    </v-form>

    <div v-if="loading" class="notification">Loading...</div>
    <div v-if="query" class="notification">Searching for: {{ query }}</div>

    <v-container v-if="iframes.length" class="masonry-container">
      <v-row>
        <v-col v-for="(iframe, index) in iframes" :key="index" cols="12" md="6">
          <v-card style="background-color: rgba(255, 255, 255, 0.1);">
            <v-card-title>Research {{ index + 1 }}</v-card-title>
            <v-card-text>
              <iframe :src="iframe.url" class="frame"></iframe>
              <p>URL: {{ iframe.url }}</p>
              <p>Time Found: {{ iframe.timeFound }}</p>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="editResearch(index)">Edit</v-btn>
              <v-btn @click="deleteResearch(index)">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    </div>
    <div elevation="3" class="chart-content-5" style="padding-block: 20px;" id="code3">
    <v-row>
      <v-col cols="12">
        <h3>Intellius Search</h3>
      </v-col>
    </v-row>
    <v-form ref="searchForm" @submit.prevent="submitSearch">
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field
              class="inputarea2 card-animate-2"
              v-model="abductor"
              label="Abductor"
              @input="populateForm"
            ></v-text-field>
            <v-switch
              v-model="abductor"
              color="success"
              value=""
              hide-details
              @change="playSound(submitAudio)"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              class="inputarea2 card-animate-2"
              v-model="lastKnownAddress"
              label="Last Known Address"
              @input="populateForm"
            ></v-text-field>
            <v-switch
              v-model="lastKnownAddress"
              color="success"
              value=""
              hide-details
              @change="playSound(submitAudio)"
            ></v-switch>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="firstName"
              label="First Name"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="lastName"
              label="Last Name"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="city" label="City" required></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="state" label="State" required></v-text-field>
          </v-col>
          <v-col cols="12" md="3">
            <v-btn type="submit">Search</v-btn>
          </v-col>
        </v-row>
      </v-form>
  
      <div v-if="loading" class="notification">Loading...</div>
      <div v-if="query" class="notification">Searching for: {{ query }}</div>
  
      <iframe v-if="iframeUrl" :src="iframeUrl" class="frame2"></iframe>
  
      <div v-if="report" class="report">
        <h2>Search Report</h2>
        <pre>{{ report }}</pre>
        <button @click="downloadReport">Download Report</button>
      </div>
    </div>
    <saved-research-list
      :saved-researches="savedResearches"
      @edit-research="editSavedResearch"
      @delete-research="deleteSavedResearch"
    ></saved-research-list>
  </v-flex>
  </v-layout>
  </v-container>
  </div>
</template>

<script>
import inputAudio from '../assets/audio/SelectNew.wav';
import submitAudio from '../assets/audio/ThinClick.wav';
import thinkingAudio from '../assets/audio/Wave.wav';
import codeCompleteAudio from "../assets/audio/input4.wav";
// import PersonSearchAI from "./PersonSearchAISpok.vue";
// import PersonDataSearchAI from "./PersonDataSearchAI.vue";
// import DetectiveLoading from "../components/DetectiveLoading.vue";

// import SavedQueryList from "./SavedQueryList.vue";
import SavedResearchList from "./SavedResearchList.vue";

export default {
  components: {
    // SavedQueryList,
    SavedResearchList,
    // PersonSearchAI,
    // PersonDataSearchAI,
    // DetectiveLoading,
  },
  data() {
    return {
      abducteeImage: null,
      abducteeImageNew: null,
      abductorImage: null,
      abductee: "",
      abducteedob: "",
      abducteedobNew: "",
      abductordob: "",
      abductor: "",
      firstName: "",
      lastName: "",
      city: "",
      state: "",
      query: "",
      iframeUrl: "",
      report: "",
      motive: "",
      abducteeRecoveryRescue: "",
      familyCountry: "",
      missingSince: "",
      abducteeSocialMedia: "",
      abductorSocialMedia: "",
      lastKnownAddress: "",
      caseType: "",
      familyRelation: "",
      familyMemberName: "",
      familyTree: {
        grandParents: [],
        parents: {
          dad: "Dad",
          mom: "Mom"
        },
        children: [],
        extendedFamily: []
      },
      datasets: [],
      currentDataset: {},
      datasetType: "",
      lastSavedQuery: "",
      lastSavedUrl: "",
      continuousMode: false,
      loading: false,
      loadingText: "",
      queryPrompt: "",
      dialogueHistory: [],
      iframes: [],
      actionSteps: [],
      currentActionIndex: 0,
      objectivesAchieved: false,
      savedQueries: [],
      savedResearches: [],
      foundDataMessage: "",
      editingQueryIndex: -1,
      inputAudio,
      submitAudio,
      thinkingAudio,
      codeCompleteAudio,
    };
  },
  mounted() {
    const storedsavedQueries = JSON.parse(localStorage.getItem("savedQueries"));
    if (storedsavedQueries) {
      this.savedQueries = storedsavedQueries;
    }

    const storedsavedResearches = JSON.parse(localStorage.getItem("savedResearches"));
    if (storedsavedResearches) {
      this.savedResearches = storedsavedResearches;
    }

    this.codeEditor.on("change", () => {
      const code = this.codeEditor.getValue();
      document.getElementById("outputIframe").srcdoc = code;
    });
    this.animateFields();
  },
  watch: {
    abductor() {
        this.populateForm();
      },
      lastKnownAddress() {
        this.populateForm();
      },
    dialogueHistory() {
      const code = this.dialogueHistory
        .map(entry => entry.text.replace(/<\/?[^>]+(>|$)/g, ""))
        .join("\n");
      this.codeEditor.setValue(code, 1);
      document.getElementById("outputIframe").srcdoc = code;
    },
  },
  methods: {
    populateForm() {
        if (this.abductor) {
          const [firstName, lastName] = this.abductor.split(" ");
          this.firstName = firstName || "";
          this.lastName = lastName || "";
        }
  
        if (this.lastKnownAddress) {
          const addressParts = this.lastKnownAddress.split(", ");
          this.city = addressParts[0] || "";
          this.state = addressParts[1] || "";
        }
  
        if (this.firstName && this.lastName && this.city && this.state) {
          this.lastSavedQuery = this.query;
          this.saveCurrentDataset();
          setTimeout(() => {
            this.submitSearchNew();
            this.submitSearch();
          }, 4000);
        }
      },
      async submitSearchNew() {
      this.loading = true;
        // new Audio(submitAudio).play();
        // this.readOutLoud('Researching Online...');
        document.getElementById('code4').scrollIntoView({ behavior: 'smooth' });
          const audio = new Audio(submitAudio);
          audio.volume = 0.3;  // Set volume to 50%
          audio.play();
        setTimeout(() => {
          this.loading = false;
          document.getElementById('code3').scrollIntoView({ behavior: 'smooth' });
          const audio = new Audio(submitAudio);
          audio.volume = 0.3;  // Set volume to 50%
          audio.play();
        }, 4000);
      if (!this.query) return;

      this.dialogueHistory.push(`<strong>User:</strong> ${this.query}`);

      try {
        const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence6`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ message: this.query }),
        });
          
        const content = await response.json();
        this.loadingText = "Executing action to achieve objective: " + content.message;
        this.readOutLoud('Searching Online...');
        this.dialogueHistory.push(`<strong>AI:</strong> ${content.message}`);
        const responseUrl = content.url;

        if (responseUrl) {
          const leftOfCenter = window.innerWidth / 2 - 450;
          window.open(responseUrl, "_blank", `left=${leftOfCenter}`);
          this.lastSavedUrl = responseUrl;
        }

        this.actionSteps = content.actionSteps || [];
        this.currentActionIndex = 0;
        this.objectivesAchieved = false;

        const searchQueries = [
          `https://www.bing.com/search?q=${this.firstName}+${this.lastName}+${this.city}+${this.state}`,
          `https://en.wikipedia.org/w/index.php?search=${this.firstName}+${this.lastName}+${this.city}+${this.state}`,
          `https://www.bing.com/images/search?q=${this.firstName}+${this.lastName}+${this.city}+${this.state}`,
          `https://www.bing.com/videos/search?q=${this.firstName}+${this.lastName}+${this.city}+${this.state}`,
        ];

        const timeNow = new Date().toLocaleString();
        this.iframes = searchQueries.map(url => ({
          url,
          timeFound: timeNow,
        }));

        this.generateReportFromIframes();
      } catch (err) {
        console.error(err);
      }
    },
      async submitSearch() {
      this.loading = true;
        // this.readOutLoud('Researching Intelius...');
        // document.getElementById('code3').scrollIntoView({ behavior: 'smooth' });
        this.query = `First Name: ${this.firstName}, Last Name: ${this.lastName}, City: ${this.city}, State: ${this.state}`;
  
        const formattedCity = this.city.split(" ").join("+");
        const url = `https://www.intelius.com/search/?firstName=${this.firstName}&lastName=${this.lastName}&city=${formattedCity}&state=${this.state}`;
        this.iframeUrl = url;
  
        // Call server to fetch and generate the report
        try {
          const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence6`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              firstName: this.firstName,
              lastName: this.lastName,
              city: this.city,
              state: this.state,
            }),
          });
          setTimeout(() => {
            this.loading = false;
            this.readOutLoud('Searching Intelius...');
          }, 1000);
          setTimeout(() => {
            this.loading = false;
            this.readOutLoud('Abduction case research results generated...');
            const audio = new Audio(codeCompleteAudio);
          audio.volume = 0.3;  // Set volume to 50%
          audio.play();
          }, 7000);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 10000);
          const data = await response.json();
          this.report = this.generateReport(data);
        } catch (error) {
          console.error("Error generating report:", error);
        } finally {
          this.loading = false;
        }
      },
      animateFields() {
      if (this.activeFieldIndex < this.fields.length) {
        setTimeout(() => {
          this.activeFieldIndex++;
          this.animateFields();
        }, 3000);
      }
    },
      generateReport(data) {
        let report = `Search Results for ${this.firstName} ${this.lastName}:\n\n`;
        report += `Addresses: ${data.addresses}\n`;
        report += `Relatives: ${data.relatives}\n`;
        report += `Age: ${data.age}\n`;
        report += `Criminal Record: ${data.criminalRecord}\n`;
        report += `Court Records: ${data.courtRecords}\n`;
        report += `Phone Numbers: ${data.phoneNumbers}\n`;
        report += `Social Media: ${data.socialMedia}\n`;
        report += `Emails: ${data.emails}\n`;
        report += `Work: ${data.work}\n`;
        report += `Dating Sites: ${data.datingSites}\n`;
        report += `Other Relevant Data: ${data.otherData}\n`;
        report += `URLs and References:\n${data.urls.join("\n")}\n`;
        return report;
      },
      downloadReport() {
        const blob = new Blob([this.report], { type: "text/plain;charset=utf-8" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `Report_${this.firstName}_${this.lastName}.txt`;
        link.click();
      },
    uploadImage(event, type) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this[type] = e.target.result;
          this.saveCurrentDataset();
        };
        reader.readAsDataURL(file);
      }
    },
    saveCurrentDataset() {
      localStorage.setItem("savedResearches", JSON.stringify(this.savedResearches));
    },
    async submitQuery() {
      if (!this.queryPrompt) return;

      const inputData = [
        `Abductee: ${this.abductee}`,
        `D.O.B: ${this.abducteedob}`,
        `D.O.B New: ${this.abducteedobNew}`,
        `Abductee New: ${this.abducteeNew}`,
        `Abductor: ${this.abductor}`,
        `Motive: ${this.motive}`,
        `Abductee Recovery/Rescue: ${this.abducteeRecoveryRescue}`,
        `Abductor D.O.B: ${this.abductordob}`,
        `Family Country: ${this.familyCountry}`,
        `Missing Since: ${this.missingSince}`,
        `Missing Since New: ${this.missingSinceNew}`,
        `Abductee Social Media Profiles: ${this.abducteeSocialMedia}`,
        `Abductee Social Media Profiles New: ${this.abducteeSocialMediaNew}`,
        `Abductor Social Media Profiles: ${this.abductorSocialMedia}`,
        `Last Known Address: ${this.lastKnownAddress}`,
        `Case Type: ${this.caseType}`,
        `Mom: ${this.familyTree.parents.mom}`,
        `Dad: ${this.familyTree.parents.dad}`,
        `Grandparents: ${this.familyTree.grandParents.map(pair => `${pair.grandpa}, ${pair.grandma}`).join(", ")}`,
        `Children: ${this.familyTree.children.map(child => child.name).join(", ")}`,
        `Extended Family: ${this.familyTree.extendedFamily.map(member => `${member.relation}: ${member.name}`).join(", ")}`,
      ].join("\n");

      this.queryPrompt = `${this.queryPrompt}\n${inputData}`;

      this.dialogueHistory.push(`<strong>User:</strong> ${this.queryPrompt}`);
      window.scrollTo(0, 330);
      new Audio(submitAudio).play();
      this.loading = true;

        this.loadingText = "Researching... (This may take a moment)";
        this.readOutLoud('Researching...');
        new Audio(thinkingAudio).play();
      try {
        const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/compelete-sentence6`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ message: this.queryPrompt }),
        });
        this.loadingText = "Generating abduction case research results...";
        this.readOutLoud('Generating abduction case research results...');
        const content = await response.json();
        new Audio(codeCompleteAudio).play();

        this.loading = false;
        this.loadingText = "Executing action to achieve objective: " + content.message;

        this.dialogueHistory.push(`<strong>AI:</strong> ${content.message}`);
        const responseUrl = content.url;

        if (responseUrl) {
          const leftOfCenter = window.innerWidth / 2 - 450;
          window.open(responseUrl, "_blank", `left=${leftOfCenter}`);
          this.lastSavedUrl = responseUrl;
          this.downloadImage(responseUrl);
        }
        this.processFoundData(content);
        window.scrollTo(0, 140);
        this.actionSteps = content.actionSteps || [];
        this.currentActionIndex = 0;
        this.objectivesAchieved = false;

        this.queryPrompt = "";
      } catch (err) {
        console.error(err);
      }
    },
    playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    processFoundData(content) {
      const regexes = [
        { field: 'abductee', regex: /Abductee:\s*(.+)/i },
        { field: 'abducteeNew', regex: /Abductee New:\s*(.+)/i },
        { field: 'abducteedob', regex: /D.O.B:\s*(.+)/i },
        { field: 'abducteedobNew', regex: /D.O.B New:\s*(.+)/i },
        { field: 'missingSinceNew', regex: /Missing Since New:\s*(.+)/i },
        { field: 'abducteeSocialMediaNew', regex: /Abductee Social Media Profiles New:\s*(.+)/i },
        { field: 'abducteeImage', regex: /Abductee Image:\s*(.+)/i },
        { field: 'abducteeImageNew', regex: /Abductee Image:\s*(.+)/i },
        { field: 'abductor', regex: /Abductor:\s*(.+)/i },
        { field: 'motive', regex: /Motive:\s*(.+)/i },
        { field: 'abducteeRecoveryRescue', regex: /Abductee Recovery\/Rescue:\s*(.+)/i },
        { field: 'abductorImage', regex: /Abductor Image:\s*(.+)/i },
        { field: 'abductordob', regex: /D.O.B:\s*(.+)/i },
        { field: 'familyCountry', regex: /Family Country:\s*(.+)/i },
        { field: 'missingSince', regex: /Missing Since:\s*(.+)/i },
        { field: 'abducteeSocialMedia', regex: /Abductee Social Media Profiles:\s*(.+)/i },
        { field: 'abductorSocialMedia', regex: /Abductor Social Media Profiles:\s*(.+)/i },
        { field: 'lastKnownAddress', regex: /Last Known Address:\s*(.+)/i },
        { field: 'caseType', regex: /Case Type:\s*(.+)/i },
        { field: 'parents.dad', regex: /Dad:\s*(.+)/i },
        { field: 'parents.mom', regex: /Mom:\s*(.+)/i },
        { field: 'grandParents', regex: /Grandparents:\s*(.+)/i },
        { field: 'children', regex: /Children:\s*(.+)/i },
        { field: 'extendedFamily', regex: /Extended Family:\s*(.+)/i },
      ];

      for (const { field, regex } of regexes) {
        const match = content.message.match(regex);
        if (match && !this[field]) {
          this[field] = match[1];
          this.showFoundDataMessage(field);
        }
      }

      const familyTreeRegexes = [
        { field: 'parents.dad', regex: /Dad:\s*(.+)/i },
        { field: 'parents.mom', regex: /Mom:\s*(.+)/i },
        { field: 'grandParents', regex: /Grandparents:\s*(.+)/i },
        { field: 'children', regex: /Children:\s*(.+)/i },
        { field: 'extendedFamily', regex: /Extended Family:\s*(.+)/i },
      ];

      for (const { field, regex } of familyTreeRegexes) {
        const match = content.message.match(regex);
        if (match) {
          const fieldPath = field.split('.');
          if (fieldPath.length === 2) {
            this.familyTree[fieldPath[0]][fieldPath[1]] = match[1];
          } else {
            const members = match[1].split(',').map(name => ({ id: Date.now(), name: name.trim() }));
            if (field === 'grandParents') {
              members.forEach((name, index) => {
                const pairIndex = Math.floor(index / 2);
                if (!this.familyTree.grandParents[pairIndex]) {
                  this.familyTree.grandParents[pairIndex] = { grandpa: '', grandma: '' };
                }
                if (index % 2 === 0) {
                  this.familyTree.grandParents[pairIndex].grandpa = name.name;
                } else {
                  this.familyTree.grandParents[pairIndex].grandma = name.name;
                }
              });
            } else {
              this.familyTree[field] = members;
            }
          }
          this.showFoundDataMessage(field);
        }
      }
    },
    showFoundDataMessage(fieldName) {
      this.foundDataMessage = `Found data for ${fieldName}`;
      setTimeout(() => {
        this.foundDataMessage = "";
      }, 3000);
    },
    resetDialogue() {
      this.queryPrompt = '';
      this.dialogueHistory = [];
      this.actionSteps = [];
      this.currentActionIndex = 0;
      this.objectivesAchieved = false;
    },
    approveAction() {
      this.executeAction(this.actionSteps[this.currentActionIndex]);
      this.nextRecommendedAction();
    },
    nextRecommendedAction() {
      if (this.currentActionIndex < this.actionSteps.length - 1) {
        this.currentActionIndex++;
      } else {
        this.currentActionIndex = 0;
      }
    },
    executeContinuousMode() {
      this.continuousMode = !this.continuousMode;

      if (this.continuousMode) {
        for (const step of this.actionSteps) {
          this.executeAction(step);
        }

        this.objectivesAchieved = true;
      }
    },
    executeAction(action) {
      console.log(`Executing action: ${action}`);
    },
    saveQuery() {
      const queryData = {
        query: this.queryPrompt,
        familyTree: this.familyTree,
        date: new Date().toLocaleString()
      };
      if (this.editingQueryIndex === -1) {
        this.savedQueries.push(queryData);
      } else {
        this.savedQueries[this.editingQueryIndex] = queryData;
        this.editingQueryIndex = -1;
      }
      localStorage.setItem("savedQueries", JSON.stringify(this.savedQueries));
    },
    updateQuery() {
      if (this.editingQueryIndex !== -1) {
        this.savedQueries[this.editingQueryIndex] = {
          query: this.queryPrompt,
          familyTree: this.familyTree,
          date: new Date().toLocaleString()
        };
        this.editingQueryIndex = -1;
        localStorage.setItem("savedQueries", JSON.stringify(this.savedQueries));
      }
    },
    saveResearch() {
      const researchData = {
        abductee: this.abductee,
        abducteeNew: this.abducteeNew,
        abducteedobNew: this.abducteedobNew,
        missingSinceNew: this.missingSinceNew,
        abducteeSocialMediaNew: this.abducteeSocialMediaNew,
        abducteedob: this.abducteedob,
        abductor: this.abductor,
        motive: this.motive,
        abducteeRecoveryRescue: this.abducteeRecoveryRescue,
        abductordob: this.abductordob,
        familyCountry: this.familyCountry,
        missingSince: this.missingSince,
        abducteeSocialMedia: this.abducteeSocialMedia,
        abductorSocialMedia: this.abductorSocialMedia,
        lastKnownAddress: this.lastKnownAddress,
        caseType: this.caseType,
        lastSavedQuery: this.queryPrompt,
        lastSavedUrl: this.lastSavedUrl,
        date: new Date().toLocaleString(),
        dialogue: this.dialogueHistory,
        familyTree: this.familyTree,
        abducteeImage: this.abducteeImage,
        abducteeImageNew: this.abducteeImageNew,
        abductorImage: this.abductorImage
      };
      this.savedResearches.push(researchData);
      localStorage.setItem("savedResearches", JSON.stringify(this.savedResearches));
    },
    editSavedResearch(index) {
      const savedResearch = this.savedResearches[index];
      this.abductee = savedResearch.abductee;
      this.abducteeNew = savedResearch.abducteeNew;
      this.abducteedobNew = savedResearch.abducteedobNew;
      this.missingSinceNew = savedResearch.missingSinceNew;
      this.abducteeSocialMediaNew = savedResearch.abducteeSocialMediaNew;
      this.abducteedob = savedResearch.abducteedob;
      this.abductor = savedResearch.abductor;
      this.motive = savedResearch.motive;
      this.abducteeRecoveryRescue = savedResearch.abducteeRecoveryRescue;
      this.abductordob = savedResearch.abductordob;
      this.familyCountry = savedResearch.familyCountry;
      this.missingSince = savedResearch.missingSince;
      this.abducteeSocialMedia = savedResearch.abducteeSocialMedia;
      this.abductorSocialMedia = savedResearch.abductorSocialMedia;
      this.lastKnownAddress = savedResearch.lastKnownAddress;
      this.caseType = savedResearch.caseType;
      this.queryPrompt = savedResearch.lastSavedQuery;
      this.dialogueHistory = savedResearch.dialogue;
      this.familyTree = savedResearch.familyTree;
      this.abducteeImage = savedResearch.abducteeImage;
      this.abducteeImageNew = savedResearch.abducteeImageNew;
      this.abductorImage = savedResearch.abductorImage;
      this.editingQueryIndex = index;
      if (savedResearch.lastSavedUrl) {
        window.open(savedResearch.lastSavedUrl, "_blank");
      }
      this.dialogueHistory.push(`<strong>User:</strong> ${this.queryPrompt}`);
    },
    deleteSavedResearch(index) {
      this.savedResearches.splice(index, 1);
      localStorage.setItem("savedResearches", JSON.stringify(this.savedResearches));
    },
    addNewDataSet() {
      const newDataSet = {
        abductee: "",
        abducteeNew: "",
        abducteedobNew: "",
        missingSinceNew: "",
        abducteeSocialMediaNew: "",
        abducteedob: "",
        abductor: "",
        motive: "",
        abducteeRecoveryRescue: "",
        abductordob: "",
        familyCountry: "",
        missingSince: "",
        abducteeSocialMedia: "",
        abductorSocialMedia: "",
        lastKnownAddress: "",
        caseType: "",
        abducteeImage: null,
        abducteeImageNew: null,
        abductorImage: null,
      };
      this.datasets.push(newDataSet);
      this.currentDataset = newDataSet;
      this.datasetType = "";
    },
    deleteDataSet() {
      if (this.datasets.length > 0) {
        this.datasets.pop();
        this.currentDataset = this.datasets[this.datasets.length - 1] || {};
      }
    },
    resetData() {
      this.currentDataset.abductee = "";
      this.currentDataset.abducteeNew = "";
      this.currentDataset.abducteedobNew = "";
      this.currentDataset.missingSinceNew = "";
      this.currentDataset.abducteeSocialMediaNew = "";
      this.currentDataset.abducteedob = "";
      this.currentDataset.abductor = "";
      this.currentDataset.motive = "";
      this.currentDataset.abducteeRecoveryRescue = "";
      this.currentDataset.abductordob = "";
      this.currentDataset.familyCountry = "";
      this.currentDataset.missingSince = "";
      this.currentDataset.abducteeSocialMedia = "";
      this.currentDataset.abductorSocialMedia = "";
      this.currentDataset.lastKnownAddress = "";
      this.currentDataset.caseType = "";
      this.currentDataset.abducteeImage = null;
      this.currentDataset.abductorImage = null;
    },
    addFamilyMember() {
      if (this.familyRelation && this.familyMemberName) {
        const newMember = { id: Date.now(), name: this.familyMemberName, relation: this.familyRelation };
        
        switch (this.familyRelation) {
          case 'Son':
          case 'Daughter':
            this.familyTree.children.push(newMember);
            break;
          case 'Mom':
            this.familyTree.parents.mom = newMember.name;
            break;
          case 'Dad':
            this.familyTree.parents.dad = newMember.name;
            break;
          case 'Grandma':
          case 'Grandpa':
            this.familyTree.grandParents.push({
              id: newMember.id,
              grandpa: this.familyRelation === 'Grandpa' ? newMember.name : 'Grandpa',
              grandma: this.familyRelation === 'Grandma' ? newMember.name : 'Grandma'
            });
            break;
          default:
            this.familyTree.extendedFamily.push(newMember);
            break;
        }
        
        this.familyRelation = '';
        this.familyMemberName = '';
      }
    },
    readOutLoud(msg) {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Female';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(voice => voice.name === voiceName)[0];
      speech.text = msg;
      window.speechSynthesis.speak(speech);
    },
  },
};
</script>
<style scoped>
.notification {
  margin-top: 10px;
  padding: 10px;
  background-color: #f0f0f0;
  border: 1px solid #ddd;
}

.report {
  margin-top: 20px;
}

.frame2 {
  width: 100%;
  height: 700px;
  border: 1px solid #ddd;
}
button {
  margin-top: 10px;
}
</style>
<style>
.abductee-image-container img,
.abductor-image-container img {
  max-width: 100%;
  height: auto;
}

.loading-container {
  text-align: center;
}

.found-data-message {
  color: green;
  font-weight: bold;
}

#familyTree {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.generation {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

.text2 {
  font-size: 1.5rem;
  font-weight: bold;
  margin: 10px 0;
  color: #ffffff;
}

.pair {
  display: flex;
  justify-content: center;
  margin: 0 10px;
}

.card-m, .card-f {
  border: 1px solid #ccc;
  padding: 10px;
  margin: 5px;
  border-radius: 5px;
  text-align: center;
  background-color: #f9f9f9;
}

.card-m {
  background-color: #d1ecf1;
}

.card-f {
  background-color: #f8d7da;
}

.abductee-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 75%;
  margin: 0 auto;
  padding: 220 10px;
  border-radius: 10px;
  outline-color: rgba(90, 128, 191, 0.5);
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
}
.chart-content-5 {
  background: rgba(12, 22, 27, 0.4);
  outline-color: rgba(90, 128, 191, 0.5);
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(120, 204, 226, 0.4), inset 0 0 10px rgba(120, 204, 226, 0.2), 0 4px 0 #000;
  color: #efe;
  outline-width: 2px;
  padding: 50px;
  border-radius: 10px;
  margin: 20px;
  min-width: 420px;
  width: 100%;
  margin-top: 6px;
  margin-left: -3px;
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
  height: 150%;
}


@media only screen and (max-width: 600px) {
.chart-content-5 {
  background: rgba(12, 22, 27, 0.4);
  outline-color: rgba(90, 128, 191, 0.5);
  outline-style: solid;
  animation: glow 1800ms ease-out infinite alternate;
  border-color: #5a80bf;
  box-shadow: 0 0 5px rgba(120, 204, 226, 0.4), inset 0 0 10px rgba(120, 204, 226, 0.2), 0 4px 0 #000;
  color: #efe;
  outline-width: 2px;
  padding: 25px;
  border-radius: 10px;
  margin: 0px;
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
  height: 150%;
}

}
.found-data-message {
  background-color: #4caf50;
  color: white;
  padding: 12px;
  margin: 10px 0;
  border-radius: 4px;
}
.ace_cursor {
  border-right: 0.15em solid orange;
  animation: blink-caret 0.5s step-end infinite;
}

/* The typewriter cursor effect */
@keyframes blink-caret {
  from,
  to {
    border-color: transparent;
  }
  50% {
    border-color: orange;
  }
}
.ace_line {
  white-space: nowrap;
  margin: 0 auto;
  letter-spacing: 0.15em;
  animation: typing 0.0001s steps(200, end);
}

/* The typing effect */
@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 5px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
  color: #fff;
  text-align: center;
  font-size: 1.3rem;
  font-weight: normal;
  font-family: Arimo, sans-serif;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
@media only screen and (max-width: 900px) {
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 25px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
}
.inputarea {
  min-width: 420px;
  width: 100%;
  height: 100%;
  overflow: auto;
  scroll-margin-bottom: 10px;
  padding: 20px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #34213d65;
  background: transparent;
  color: rgb(36, 212, 65);
  font-size: 16px;
  resize: none;
  margin: 0px 0px 10px 0px;
}
.inputarea2 {
  width: 100%;
  height: 80px;
  padding: 20px 20px;
  box-sizing: border-box;
  border: 1px solid #37a877;
  border-radius: 15px;
  margin: 10px 15px;
  background-color: #f8f8f800;
  font-size: 16px;
  resize: none;
}

#codeEditor {
    width: 100%;
    height: 400px;
}
  #outputIframe {
    width: 100%;
    height: 400px;
    border: 1px solid #ccc;
  }
  
  #dialogueResults {
    padding: 10px;
    border: 1px solid #ccc;
    margin-bottom: 10px;
    max-height: 200px;
    overflow-y: auto;
  }
  #savedProjects {
  padding: 10px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  max-height: 200px;
  overflow-y: auto;
}
</style>


<style lang="scss">

@import url('https://fonts.googleapis.com/css?family=Dancing+Script:700|Roboto:300,400');

// MIXINS

@mixin flexBox {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
}

@mixin flex($flexGrow:"1", $flexShrink:"1", $flexBasis:"0%") {
	-webkit-box-flex: #{$flexGrow};
	-ms-flex-positive: #{$flexGrow};
	flex-grow: #{$flexGrow};

	-ms-flex-negative: #{$flexShrink};
	flex-shrink: #{$flexShrink};

	-ms-flex-preferred-size: #{$flexBasis};
	flex-basis: #{$flexBasis};
}

@mixin flexDirection($flexDirection:"column") {
	@if $flexDirection == "row" {
		-webkit-box-orient: horizontal;
		-webkit-box-direction: normal;
	} @else if $flexDirection == "row-reverse" {
		-webkit-box-orient: horizontal;
		-webkit-box-direction: reverse;
	} @else if $flexDirection == "column" {
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
	} @else {
		-webkit-box-orient: vertical;
		-webkit-box-direction: reverse;
	}

	-ms-flex-direction: #{$flexDirection};
	flex-direction: #{$flexDirection};
}

// PAGE BASE

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

html {
	height: 100%;
	@include flexBox();
	background-color: #f0f0e8;
}

body {
	background-color: #f0f0e8;
	font-family: 'Roboto', cursive;
	font-size: 14px;
	width: 60%;
	text-align: center;
	margin: auto;
}

h1 {
	color: #41669d;
	font-family: 'Dancing Script', cursive;
	font-size: 60px;
	margin: 20px 0px 30px;
	text-align: center;
	
	span {
		display: block;
		font-size: 25px;
		color: #aab4af;
	}
}

@media screen and (max-width: 400px) {
	h1 { font-size: 40px; }
	h1 span { font-size: 20px; }
}

// FAMILY TREE
// Try keeping the same content's size for all cards or the design might break
// Have fun with the variables :)

$linkBorderWidth: 2px;
$link: #{$linkBorderWidth} solid #c6d1cb;
$marginBelowGeneration: 20px;
$cardMargin: 10px;
$borderRadius: 3px;
$extraBorderSize: #{$borderRadius}; // Needed for border-radius

#familyTree {
	// Base styles
	
	*:before, *:after {
		content: "";
		position: absolute;
	}
	
	[class^="card"], .pair, .generation { position: relative; }
	
	.generation {
		@include flexBox();
		margin-bottom: $marginBelowGeneration;
		
		.pair {
			@include flex();
			@include flexBox();
		}
		
		&:last-of-type { margin-bottom: 0; }
	}
	
	[class^="card"] {
		@include flex();
		padding: 10px;
		border-radius: 3px;
		margin: $cardMargin;
		color: #212c3c;
	}
	
	.card-m { background-color: #b8c9df; } // Male
	.card-f { background-color: #dfb8d4; } // Female
	
	// Links
	
	.pair {
		&:after {
			width: calc(50% - #{$linkBorderWidth});
			border: $link;
			border-top: 0;
			border-bottom-left-radius: $borderRadius;
			border-bottom-right-radius: $borderRadius;
			right: 0;
			left: 0;
			margin: auto;
			top: calc(100% + #{$marginBelowGeneration} / 2 - #{$extraBorderSize});
			height: $extraBorderSize;
		}
	}
	
[class^="card"] {
		&:before, &:after {
			right: 0;
			left: 0;
			width: 0;
			margin: auto;
			border-left: $link;
			height: calc(#{$cardMargin} + #{$marginBelowGeneration} / 2);
		}

		&:before { bottom: 100%; }
		&:after { top: 100%; }
	}

	#grandParents [class^="card"]:before, #child [class^="card"]:after {
		border: 0;
		opacity: 0;
	}
}

// Responsive

@media screen and (max-width: 700px) {
	#familyTree #grandParents {
		
		&:before, &:after {
			border-top: $link;
			height: calc(50% + #{$marginBelowGeneration});
			width: $cardMargin;
			top: 50%;
		}
		
		&:before {
			opacity: 1;
			border-left: $link;
			right: calc(100% + #{$extraBorderSize});
			border-top-left-radius: $borderRadius;
		}
		
		&:after {
			border-right: $link;
			left: calc(100% + #{$extraBorderSize});
			border-top-right-radius: $borderRadius;
		}
		
		.pair {
			@include flexDirection();
			&:after { border: 0; }
		}

		[class^="card"] {
			&:before {
				border-bottom: $link !important;
				width: $cardMargin;
				height: 0;
			}

			&:after {
				width: calc(#{$extraBorderSize} + #{$cardMargin});
				height: calc(50% + #{$cardMargin} + #{$extraBorderSize} * 2);
			}

			&:first-child {
				&:before {
					top: 50%;
					bottom: auto;
				}

				&:after {
					border-top: $link;
					top: 50%;
					bottom: auto;
				}
			}

			&:last-child {
				&:before {
					bottom: 50%;
					top: auto;
				}

				&:last-child:after {
					border-bottom: $link;
					bottom: 50%;
					top: auto;
				}
			}
		}

		.pair:first-child [class^="card"] {
			&:before {
				left: -#{$cardMargin};
				right: auto;
			}

			&:after {
				left: auto;
				right: 100%;
			}

			&:first-child:after { border-top-left-radius: $borderRadius; }
			&:last-child:after { border-bottom-left-radius: $borderRadius; }
		}

		.pair:last-child [class^="card"] {
			&:before {
				right: -#{$cardMargin};
				left: auto;
			}

			&:after {
				left: 100%;
				right: auto;
				border-left: 0;
				border-right: $link;
			}

			&:first-child:after { border-top-right-radius: $borderRadius; }
			&:last-child:after { border-bottom-right-radius: $borderRadius; }
		}
	}

	#familyTree #parents [class^="card"] {
		&:before {
			border-bottom: $link;
			width: calc(#{$cardMargin} * 2 + #{$extraBorderSize});
			bottom: 50%;
			height: calc(50% + #{$cardMargin});
		}

		&:first-child:before {
			right: 100%;
			left: auto;
			border-bottom-left-radius: $borderRadius;
		}

		&:last-child:before {
			border-left: 0;
			border-right: $link;
			left: 100%;
			border-bottom-right-radius: $borderRadius;
		}
	}
}

@media screen and (max-width: 400px) {
	#familyTree #grandParents {
		@include flexDirection();
		
		&:before {
			top: 25%;
			height: calc(75% + #{$marginBelowGeneration});
		}
		
		&:after {
			top: 75%;
			height: calc(25% + #{$marginBelowGeneration});
		}
	}
	
	#familyTree #parents {
			&:after {
				border-left: $link;
				border-top: $link;
				border-top-left-radius: $borderRadius;
				height: calc(50% + #{$marginBelowGeneration});
				width: $cardMargin;
				right: calc(100% + #{$extraBorderSize});
				top: 50%;
			}
		
		.pair {
			@include flexDirection();
			
			&:after {
				border: 0;
				height: 0;
				opacity: 0;
			}
		}
		
		[class^="card"] {
			&:after {
				right: 100%;
				left: auto;
				width: calc(#{$extraBorderSize} + #{$cardMargin});
			}
		}
		
		[class^="card"]:first-child {
			&:before {
				height: 90%;
				bottom: 60%;
			}
		
			&:after {
				border-top: $link;
				height: calc(40% + #{$cardMargin});
				top: 60%;
				border-top-left-radius: $borderRadius;
			}
		}
		
		[class^="card"]:last-child {
			&:before { height: calc(150% + #{$cardMargin}* 3); }
			
			&:after {
				border-bottom: $link;
				height: calc(50% + #{$cardMargin});
				bottom: 50%;
				top: auto;
				border-bottom-left-radius: $borderRadius;
			}
		}
	}
	
	#familyTree #child {
		&:before {
			border-left: $link;
			border-bottom: $link;
			border-bottom-left-radius: $borderRadius;
			height: 100%;
			bottom: 50%;
			right: calc(100% - #{$cardMargin});
			left: auto;
			width: calc(#{$extraBorderSize} + #{$cardMargin} * 2);
		}
		
		[class^="card"]:before {
			border: 0;
			height: 0;
			opacity: 0;
		}
	}
}


</style>

<style scoped>
.notification {
  margin-top: 10px;
  padding: 10px;
  background-color: rgba(240, 240, 240, 0.8); /* Transparent background */
  border: 1px solid #ddd;
}

.report {
  margin-top: 20px;
}

.report-content {
  background-color: rgba(255, 255, 255, 0.8); /* Transparent background */
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.frame {
  border: none;
  width: 600px;
  height: 500px;
  border-radius: 10px;
}

button {
  margin-top: 10px;
}

.map-container {
  margin-top: 20px;
}

.masonry-container {
  display: flex;
  flex-wrap: wrap;
}

.masonry-container .v-col {
  margin-bottom: 16px;
}
</style>
